import React, { FC, useEffect, useState } from 'react';
import { Flex, View } from '@adobe/react-spectrum';

import { ContentModel } from '~/Scene/Content/contentModel';

import {
    ContentEvent, contentObservable, uploadModel
} from '~/Services/Studio/Contents';
import { ModelButton } from './modelButton';
import { _contentsManager } from '~/Services/Studio/studioScene';
import { Observable } from '~/Utils/observable';
import { UploadButton } from '~/Components/Upload/uploadButton';

export enum ModelSelectEvent {
    Select,
    Add,
    Delete
}

class ModelSelectObservable extends Observable<ModelSelectEvent, ContentModel> {
    constructor() {
        super('MODEL_SELECT');
    }
}

export const modelSelectObservable = new ModelSelectObservable();

interface IModelListProps {
    onSelect: (c: ContentModel) => void;
}

export const ModelList: FC<IModelListProps> = ({
    onSelect,
}: IModelListProps) => {
    const [selectedModel, setSelectedModel] = useState<string>();
    const [models, setModels] = useState<ContentModel[]>([]);

    const selectModel = (model: ContentModel) => {
        if (model) setSelectedModel(model.id);
        onSelect(model);
        modelSelectObservable.notify(ModelSelectEvent.Select, model);
    };

    const refreshList = () => {
        const models = _contentsManager.getContentModels();
        setModels(models);
    };

    const deleteModel = () => {
        refreshList();
        selectModel(null);
    };

    useEffect(() => {
        refreshList();
        const models = _contentsManager.getContentModels();
        if (models.length) selectModel(models[0]);

        contentObservable.on(ContentEvent.UploadEnd, refreshList);
        return function cleanup() {
            contentObservable.off(ContentEvent.UploadEnd, refreshList);
        };
    }, []);

    const onAddDrop = (files) => {
        const file = files[0];
        uploadModel(file);
    };

    return (
        <Flex direction="row" gap="size-100">
            <Flex direction="column" gap="size-100">
                {models.map((model) => (
                    <ModelButton
                        key={model.id}
                        model={model}
                        onSelect={() => { selectModel(model); }}
                        onDelete={() => { deleteModel(); }}
                        selected={model.id === selectedModel}
                    />
                ))}
            </Flex>
            <View flex />
            <UploadButton
                extensions={['.zip', '.gltf', '.glb']}
                label="Model"
                onDrop={onAddDrop}
            />
        </Flex>
    );
};
